import chroma from 'chroma-js';
import { designSystemColors } from './colors';


function getTextBasedOnBackground(rgba: string): string {
  // Parse the input to create a Chroma object
  const bgColor = chroma(rgba);

  // Calculate the contrast with both charcoal and white
  const contrastWithCharcoal = chroma.contrast(bgColor, 'rgb(35, 33, 33)');
  const contrastWithWhite = chroma.contrast(bgColor, 'white');

  // Decide based on contrast ratios which color to use
  return contrastWithWhite >= contrastWithCharcoal ? 'white' : 'charcoal';
}

export const backgroundToTextColor: { [key: string]: string; } = {};

for (const [key, value] of Object.entries(designSystemColors)) {
  backgroundToTextColor[key] = `var(--color-core-${getTextBasedOnBackground(value)})`;
}
